import { faFlag, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Alert, Button, Col, Modal, Row, Table } from "react-bootstrap";
import BihamtaTable from "../../../Components/BihamtaTable";
import { addOrUpdateServiceStatus, getServiceStatusListForManage, deleteServiceStatus } from "../../store/api/Services";
import { useDispatch } from "react-redux";
import { isWebApp, setErrorDialog, useIsMobileApp } from "../../../store/api/CommonFunctions";
import ServiceStages from "../../content/images/ServiceStages.png";
import { CheckLg, DashCircle, PencilFill, PlusSquareFill } from "react-bootstrap-icons";

const ModalServiceStatusManagement = (props) => {
    const { show, close } = props;
    const dispatch = useDispatch();
    const [current, setCurrent] = useState(null);
    const [dataList, setDataList] = useState();
    const isMobile = useIsMobileApp();
    const [submitError, setSubmitError] = useState(null);
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "Status", colTitle: "نام وضعیت", showInMobile: true },
        { colName: "StatusMessage", colTitle: "نام قابل نمایش به مشتری", showInMobile: true },
        { colName: "StageName", colTitle: "نام مرحله", colType: "string" },
    ]
    const rowButtons = [
        { type: "common", icon: <PencilFill color="orange" size={18} />, onclick: selectForEdit },
        { type: "delete", onclick: delStatus }
    ]
    function selectForEdit(row) {
        if (current) {
            setErrorDialog(dispatch, "ابتدا ردیف کنونی را به سرانجام برسانید","مدیریت وضعیت سرویس");
            return;
        }
        delete row.e;
        setCurrent(row);
    }
    function prepareForAdd() {
        setCurrent({ ID: 0 });
    }
    function cancelCurrent() {
        setCurrent(null);
    }
    function submitStatus() {
        setSubmitError(null);
        if ((current.Status ?? "") === "") {
            setSubmitError("نام وضعیت وارد نشده است");
            return;
        }
        const onAddEdit = (res) => {
            if (res.Data) {
                // setErrorDialog(dispatch, "success","ثبت/ویرایش سرویس");
                getServiceStatusListForManage(setDataList);
                setCurrent(null);
            }
            else if (res.Error) {
                setSubmitError(res.Error);
            }

        }
        addOrUpdateServiceStatus(current, onAddEdit);
    }
    function delStatus(row) {
        if (current) {
            setErrorDialog("ابتدا ردیف کنونی را به سرانجام برسانید");
            return;
        }
        const onDelete = (res) => {
            if (res.Data) {
                setDataList({Data:dataList.Data.filter(s => Number(s.ID) !== Number(row.ID))});
            }
            else if (res.Error) {
                setSubmitError(res.Error);
            }

        }
        deleteServiceStatus(row.ID, onDelete);
    }
    function onClose(){
        setCurrent(null);
        close();
    }
    useEffect(() => {
        if (show)
            getServiceStatusListForManage(setDataList);
    }, [show])
    return (
        <Modal show={show} size="lg" onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faFlag} size="lg"/>&nbsp;
                    مدیریت وضعیت سرویس
                </span>
                <FontAwesomeIcon icon={faTimes} onClick={onClose} size="lg" />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {submitError &&
                    <Alert variant="danger">
                        {submitError}
                        <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setSubmitError(null)} />
                    </Alert>}
                <PlusSquareFill size={25} className="hoverIcon mb-1" onClick={prepareForAdd} color="#134df3" style={{ cursor: "pointer" }} />
                {current &&
                    <Row className="rowBorder scThin" style={{ overflow: "auto" }}>
                        <table style={{ whiteSpace: "nowrap", minWidth: "750px", textAlign:"center" }}>
                            <thead>
                                <th style={{ padding: "1px", textAlign:"right" }}>نام وضعیت</th>
                                <th style={{ padding: "1px", textAlign:"right" }}>نام نمایشی</th>
                                <th style={{ padding: "1px" }}>پذیرش</th>
                                <th style={{ padding: "1px" }}>توزیع کار</th>
                                <th style={{ padding: "1px" }}>تعمیرگاه</th>
                                <th style={{ padding: "1px" }}>کنترل کیفیت</th>
                                <th style={{ padding: "1px" }}>خروج</th>
                                <th style={{ padding: "1px" }}>رنگ</th>
                            </thead>
                            <tbody>
                                <td style={{ padding: "1px" }}><input className="tableRowInput" style={{borderRadius:"2px"}} defaultValue={current.Status ?? ""} onChange={e => current.Status = e.target.value} /></td>
                                <td style={{ padding: "1px" }}> <input className="tableRowInput"style={{borderRadius:"2px"}} defaultValue={current.StatusMessage ?? ""} onChange={e => current.StatusMessage = e.target.value} /></td>
                                <td style={{ padding: "1px" }}><input type="radio" name="stage"style={{borderRadius:"2px"}} className="form-check-input" onChange={e => current.StageHardCode="Reception"}
                                    defaultChecked={current.StageHardCode ==="Reception"} /></td>
                                <td style={{ padding: "1px" }}> <input type="radio" name="stage"style={{borderRadius:"2px"}} className="form-check-input" defaultChecked={current.StageHardCode ===".Distribution"} onChange={e => current.StageHardCode = "Distribution" } /></td>
                                <td style={{ padding: "1px" }}> <input type="radio" name="stage"style={{borderRadius:"2px"}} className="form-check-input" defaultChecked={current.StageHardCode ===".Workshop"} onChange={e => current.StageHardCode = "Workshop"} /></td>
                                <td style={{ padding: "1px" }}> <input type="radio" name="stage"style={{borderRadius:"2px"}} className="form-check-input" defaultChecked={current.StageHardCode ===".QC"} onChange={e => current.StageHardCode ="QC"} /></td>
                                <td style={{ padding: "1px" }}> <input type="radio" name="stage"style={{borderRadius:"2px"}} className="form-check-input" defaultChecked={current.StageHardCode ===".Exit"} onChange={e => current.StageHardCode="Exit"} /></td>
                                <td style={{ padding: "1px" }}><input type="color" defaultValue={current.BackgroundColor ?? "#ece4e4"} onChange={e => current.BackgroundColor = e.target.value} /></td>
                            </tbody>
                        </table>
                        <div>
                            <Button className="group-Btn" variant="success" onClick={submitStatus}><CheckLg size={16} />&nbsp; ثبت اطلاعات</Button>
                            <Button className="group-Btn" variant="danger" onClick={cancelCurrent}><DashCircle size={16} />&nbsp; انصراف</Button>
                        </div>
                    </Row>
                }
                <BihamtaTable rowButtons={rowButtons} columns={tableCols} dataList={dataList} style={{ whiteSpace: "nowrap" }} maxHeight={373} className="mt-0 mb-0" />
                {!isMobile &&
                    <div style={{ textAlign: "center", height: "20vh" }}>
                        <img src={ServiceStages} height="100%" />
                    </div>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalServiceStatusManagement;